const AppConfig = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  DEFAULT_DATE_FORMAT: process.env.REACT_APP_DEFAULT_DATE_FORMAT || 'DD-MM-YYYY',
};

export default AppConfig;
